<template>
    <v-layout justify-center>
        <v-responsive width="100%" height="100%">
            <list-heading title="교환 내역" v-model="showsSearch" showsFilterButton />

            <list-search-default
                v-bind="{
                    showsSearch,
                    loading,
                    searchKeys,
                }"
                v-on="{ search }"
            />

            <v-row class="ma-n2 mt-n1">
                <v-col class="pa-2" cols="12">
                    <v-row class="ma-n2">
                        <v-col class="pa-2" cols="auto">
                            <user-exchange-list-code />
                        </v-col>
                        <v-col class="pa-2" cols="auto">
                            <user-exchange-list-type />
                        </v-col>
                        <v-spacer />
                        <v-col class="pa-2" cols="auto">
                            <list-excel v-slot="{ attrs, on }" v-on="{ excel }">
                                <v-card outlined style="overflow: hidden;">
                                    <v-btn color="white" elevation="0" class="text-caption green--text" style="margin:-1px" v-bind="{ ...attrs, loading }" v-on="on">
                                        <v-icon> mdi-microsoft-excel </v-icon>
                                        <span> 엑셀다운로드 </span>
                                    </v-btn>
                                </v-card>
                            </list-excel>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col class="pa-2" cols="12">
                    <v-data-table v-bind="{ loading, headers, items }" disable-sort disable-pagination hide-default-footer class="v-sheet--outlined" :items-per-page="-1" ref="data-table">
                        <template v-for="(header, index) in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> <span :key="index" :title="header.withTitle ? header.formatter.bind(item)(value, item) : undefined" v-html="header.formatter.bind(item)(value, item)" /> </template>
                        <template #[`item.member`]="{ value }">
                            {{ headers.find((item) => item.value == "member").formatter(value) }}
                        </template>

                        <template #footer>
                            <v-divider />
                            <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" class="my-2" @input="(page) => $router.push({ query: { ...$route.query, page } })" />
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";

import { mapGetters } from "vuex";

import { initDataTableHeaders, initUserExchange, USER_EXCHANGE_CODES } from "@/assets/lib";

import ListExcel from "@/components/console/dumb/list-excel.vue";
import ListHeading from "@/components/console/dumb/list-heading.vue";
import ListSearchDefault from "@/components/console/dumb/list-search-default.vue";

import UserExchangeListCode from "@/components/console/user-exchanges/user-exchange-list-code.vue";
import UserExchangeListType from "@/components/console/user-exchanges/user-exchange-list-type.vue";

const searchKeys = [
    { text: "교환권 번호", value: "prev" },
    { text: "나누리핀 번호", value: "next" },
    { text: "상품권 종류", value: "name" },
    { text: "교환회원(이름/아이디)", value: "member" },
    { text: "선물정보(이름/아이디/연락처)", value: "gift" },
];

export default {
    components: {
        ListExcel,
        ListHeading,
        ListSearchDefault,

        UserExchangeListCode,
        UserExchangeListType,
    },
    data: () => ({
        exchanges: [],

        limit: 20,
        summary: { totalCount: 0 },

        searchKeys,

        loading: false,
        showsSearch: true,
    }),
    computed: {
        ...mapGetters(["hasCompanyScope", "hasConsoleScope"]),
        headers() {
            const headers = initDataTableHeaders([
                {
                    text: "순번",
                    value: "index",
                    width: 100,
                    align: "end",
                    formatterType: "number",
                },
                {
                    text: "교환일시",
                    value: "createdAt",
                    width: 110,
                    formatterType: "datetime",
                },
                {
                    text: "교환소",
                    value: "code",
                    width: +90,
                    formatter: (code) => USER_EXCHANGE_CODES[code]?.text,
                },
                {
                    text: "교환권 번호",
                    value: "prev",
                },
                {
                    text: "나누리핀 번호",
                    value: "next",
                },
                {
                    text: "금액",
                    value: "amount",
                    width: 110,
                    align: "end",
                    formatterType: "number",
                    suffix: "원",
                },
                {
                    text: "상품권 종류",
                    value: "name",
                },
                {
                    text: "상태",
                    value: "type",
                    width: 100,
                    align: "center",
                },
                {
                    text: "교환회원\n(이름/ID)",
                    width: 100,
                    value: "member",
                    formatter: (value) => (value ? [value.name, value.username].join("\n") : "-"),
                    cellClass: "white-space-pre-line",
                },
                {
                    text: "선물정보\n(이름/아이디/연락처)",
                    width: 140,
                    value: "gift",
                    formatter: (value) => (value ? [value.giftee?.name, value.giftee?.username, value.phone].filter((item) => item).join("\n") : "-"),
                    cellClass: "white-space-pre-line",
                },
            ]);
            return headers.filter(({ shows }) => shows ?? true).map((header) => ({ ...header, withTitle: true }));
        },
        items() {
            return [...this.exchanges].map(initUserExchange).map((item, index) => ({
                ...item,
                index: this.summary.totalCount - index - this.skip,
            }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { type, ...query } = this.$route.query;

            delete query.page;

            switch (type) {
                case "cashed": {
                    query.cashed = true;
                    query.gifted = JSON.stringify({ $ne: true });
                    break;
                }
                case "gifted": {
                    query.cashed = JSON.stringify({ $ne: true });
                    query.gifted = true;
                    break;
                }
                case "gifted-cashed": {
                    query.cashed = true;
                    query.gifted = true;
                    break;
                }
                case "isDone": {
                    query.cashed = JSON.stringify({ $ne: true });
                    query.gifted = JSON.stringify({ $ne: true });
                    break;
                }

                default:
                    break;
            }

            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        async init() {
            this.exchanges = [];
            this.summary = { totalCount: 0 };
            this.loading = false;

            await this.search();
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;
            try {
                let { skip, limit, params } = this;
                let { summary, exchanges } = await api.console.userExchanges.gets({
                    headers: { skip, limit },
                    params,
                });

                this.summary = summary;
                this.exchanges = exchanges;
            } finally {
                this.loading = false;
            }
        },

        async excel({ skip = 0, limit = 0 } = {}) {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { params } = this;
                let { exchanges } = await api.console.userExchanges.gets({
                    headers: { skip, limit },
                    params,
                });

                let { headers } = this;
                let fileName = "교환내역";
                this.$excel(exchanges, headers, fileName);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .line-height-1-5 {
        line-height: 1.5;
    }
    .max-width-0 {
        max-width: 0;
    }
    .word-break-keep-all {
        word-break: keep-all;
    }
    .white-space-pre-line {
        white-space: pre-line;
    }
    .cursor-pointer {
        cursor: pointer;
    }
    .v-pagination button {
        box-shadow: none !important;
        border: thin solid rgba(0, 0, 0, 0.12);
    }
    .v-small-dialog__activator {
        height: 100%;
    }
    .v-small-dialog__activator__content {
        width: 100%;
    }

    th:first-of-type:not(:last-of-type),
    td:first-of-type:not(:last-of-type) {
        border-right: thin solid rgba(0, 0, 0, 0.12);
    }

    .v-data-table__expanded__content {
        box-shadow: none !important;
    }
    .vertical-align-top {
        vertical-align: top !important;
    }
    .vertical-align-middle {
        vertical-align: middle !important;
    }
}
</style>
